/**
 * Vergleich von Versionsnummern der Form `MAJOR.MINOR.PATCH` (Versions-Sperre der App, P5). Bewusst ohne
 * Bibliothek: Nur drei Zifferngruppen, kein Vorabversions- oder Build-Anhang.
 */

/** `null` bei ungültiger Form. */
export function parseVersion(value: string): [number, number, number] | null {
  const match = /^(\d{1,9})\.(\d{1,9})\.(\d{1,9})$/.exec(value.trim());
  if (match === null) return null;
  return [Number(match[1]), Number(match[2]), Number(match[3])];
}

/** `-1`/`0`/`1` wie bei `Array.sort`. Ungültige Werte gelten als kleinstmöglich (sicherer Ausfall: eher sperren). */
export function compareVersions(a: string, b: string): number {
  const left = parseVersion(a) ?? [-1, -1, -1];
  const right = parseVersion(b) ?? [-1, -1, -1];
  for (let index = 0; index < 3; index += 1) {
    const diff = (left[index] ?? 0) - (right[index] ?? 0);
    if (diff !== 0) return diff < 0 ? -1 : 1;
  }
  return 0;
}

/** `current` erfüllt die Mindestversion `min` (auch bei `min === null`, dann gibt es keine Sperre). */
export function meetsMinVersion(current: string, min: string | null): boolean {
  if (min === null) return true;
  return compareVersions(current, min) >= 0;
}
